import React, { useState, useEffect } from 'react';

const WebinarAttendeeCount = ({ socket, webinar_id, mode = 'live' }) => {
	const [attendees, setAttendees] = useState(
		mode === 'simulated' ? Math.floor(Math.random() * 281) + 120 : null
	);

	const styles = {
		container: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'center',
			padding: '10px 0',
			border: '1px solid #ccc',
			backgroundColor: '#f9f9f9'
		},
		attendeeText: {
			fontSize: '16px',
			color: '#777'
		}
	};

	const mobileStyles = {
		container: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'center',
			padding: '0px 0'
		},
		attendeeText: {
			fontSize: '12px'
		}
	};

	// Use window.innerWidth to determine screen width
	const isMobile = window.innerWidth <= 768;

	// Use either styles or mobileStyles based on screen width
	const appliedStyles = isMobile ? mobileStyles : styles;

	useEffect(() => {
		if (mode === 'simulated') {
			// Randomly fluctuate the count every 30-90 seconds
			const interval = setInterval(() => {
				setAttendees((prev) => {
					const change = Math.floor(Math.random() * 11) - 5; // -5 to +5
					return Math.max(50, prev + change);
				});
			}, 30000 + Math.random() * 60000);

			return () => clearInterval(interval);
		}

		if (mode === 'live') {
			if (!socket || !webinar_id) return;

			const fetchCount = () => {
				socket.emit('get-attendee-count', { webinar_id });
			};

			socket.on('attendee-count', (data) => {
				if (data.webinar_id === webinar_id) {
					setAttendees(data.count + 4);
				}
			});

			fetchCount();
			const interval = setInterval(fetchCount, 60000);

			return () => {
				clearInterval(interval);
				socket.off('attendee-count');
			};
		}
	}, [socket, webinar_id, mode]);

	if (attendees === null) return null;

	return (
		<div style={appliedStyles.container}>
			<p style={appliedStyles.attendeeText}>
				Currently {attendees} people on the webinar
			</p>
		</div>
	);
};

export default WebinarAttendeeCount;
